import { Component } from '@angular/core';

@Component({
  selector: 'app-projet-list-item',
  templateUrl: './projet-list-item.component.html',
  styleUrls: ['./projet-list-item.component.scss']
})
export class ProjetListItemComponent {

    generateHtmlFromTemplate() {
        return 'test';
    }
}
